const errorProcessor = (error) => {
  let err = error.response
    ? error.response
    : (error.response = {
        data: {
          status: 400,
          error:
            "Ooops! Network Error. Please check your internet connection and try again",
        },
      });
  err = error.response.data.message
    ? error.response.data.message
    : error.response.data.error;
  err = typeof err === "object" ? err : [err];
  return err;
};

export default errorProcessor;
